import { useEffect } from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Layout from "@/components/Layout";
import PrivacyBanner from "@/components/PrivacyBanner";
import HomePage from "@/pages/HomePage";
import UnderstandingPage from "@/pages/UnderstandingPage";
import UnderstandingRecordsPage from "@/pages/UnderstandingRecordsPage";
import RecordsCheatSheetPage from "@/pages/RecordsCheatSheetPage";
import RecordsTemplatesPage from "@/pages/RecordsTemplatesPage";
import ChronologyPage from "@/pages/ChronologyPage";
import MeetingPrepPage from "@/pages/MeetingPrepPage";
import QuestionCardsPage from "@/pages/QuestionCardsPage";
import MeetingDebriefPage from "@/pages/MeetingDebriefPage";
import ComplaintLetterPage from "@/pages/ComplaintLetterPage";
import GlossaryPage from "@/pages/GlossaryPage";
import SupportPage from "@/pages/SupportPage";
import CampaignPage from "@/pages/CampaignPage";
import StoriesPage from "@/pages/StoriesPage";
import StoryShareForm from "@/pages/StoryShareForm";
import JournalPage from "@/pages/JournalPage";
import JournalPostPage from "@/pages/JournalPostPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPage from "@/pages/PrivacyPage";
import AboutPage from "@/pages/AboutPage";
import NotFoundPage from "@/pages/NotFoundPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminMessagesPage from "@/pages/admin/AdminMessagesPage";
import AdminJournalListPage from "@/pages/admin/AdminJournalListPage";
import AdminJournalEditPage from "@/pages/admin/AdminJournalEditPage";
import AdminStoriesPage from "@/pages/admin/AdminStoriesPage";
import AuthCallback from "@/pages/AuthCallback";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return (
      <Layout>
        <AuthCallback />
      </Layout>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/understanding" element={<UnderstandingPage />} />
        <Route path="/understanding/records" element={<UnderstandingRecordsPage />} />
        <Route path="/understanding/records/cheat-sheet" element={<RecordsCheatSheetPage />} />
        <Route path="/understanding/records/templates" element={<RecordsTemplatesPage />} />
        <Route path="/understanding/records/chronology" element={<ChronologyPage />} />
        <Route path="/understanding/meeting-prep" element={<MeetingPrepPage />} />
        <Route path="/understanding/meeting-prep/cards" element={<QuestionCardsPage />} />
        <Route path="/understanding/meeting-prep/debrief" element={<MeetingDebriefPage />} />
        <Route path="/understanding/records/complaint" element={<ComplaintLetterPage />} />
        <Route path="/glossary" element={<GlossaryPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/campaign" element={<CampaignPage />} />
        <Route path="/stories" element={<StoriesPage />} />
        <Route path="/stories/share" element={<StoryShareForm />} />
        <Route path="/journal" element={<JournalPage />} />
        <Route path="/journal/:slug" element={<JournalPostPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminMessagesPage />} />
          <Route path="journal" element={<AdminJournalListPage />} />
          <Route path="journal/new" element={<AdminJournalEditPage />} />
          <Route path="journal/:id" element={<AdminJournalEditPage />} />
          <Route path="stories" element={<AdminStoriesPage />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AppRouter />
        <PrivacyBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
